import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { Icon } from '../components/Icon';

export interface AlertProps extends MuiAlertProps {
  title?: string;
}

export const Alert: React.FC<AlertProps> = ({
  children,
  sx,
  title,
  color,
  severity = 'info',
  ...otherProps
}) => {
  const iconStyles = { mt: '2px' };

  const finalColor = color || severity;

  const styles = () => {
    return {
      bgcolor: `${finalColor}.backgroundSoft`,
      color: `${finalColor}.text`,
      '& .MuiAlert-icon': {
        color: `${finalColor}.text`,
      },
      '& .MuiAlert-action': {
        color: `${finalColor}.text`,
      },
    };
  };

  return (
    <MuiAlert
      sx={[styles, ...(Array.isArray(sx) ? sx : [sx])]}
      color={color}
      severity={severity}
      iconMapping={{
        success: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'check-circle', style: 'regular' })}
          />
        ),
        info: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'info-circle', style: 'regular' })}
          />
        ),
        warning: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'exclamation-triangle', style: 'regular' })}
          />
        ),
        error: (
          <Icon
            sx={iconStyles}
            icon={icon({ name: 'exclamation-circle', style: 'regular' })}
          />
        ),
      }}
      {...otherProps}
    >
      {title && <AlertTitle sx={{ fontWeight: 400 }}>{title}</AlertTitle>}
      {children}
    </MuiAlert>
  );
};
